import styled, {css} from "styled-components";
import {Title1} from "../../../../styles/business-components";

import Basic from '../../../../assets/images/business/b_m_cnt13_basic.svg';
import Pro from '../../../../assets/images/business/b_m_cnt13_pro.svg';
import Enterprise from '../../../../assets/images/business/b_m_cnt13_ent.svg';
import {CardItemProps, CardProps, CardVariant} from "./Card";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  height: 1200px;
  padding: 100px 50px;
  text-align: center;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    height: 1300px;
    padding: 100px 200px;
  }
`

export const Title = styled(Title1)`
  margin-bottom: 0;
`

export const Slider = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  height: 800px;
  align-items: center;
  justify-content: center;
`

function positioning(activeIndex, rowNumber, w, h) {
  const isActive = activeIndex === rowNumber;
  const width = isActive ? `${w}px` : `${w / 1.25}px`;
  const height = isActive ? `${h}px` : `${h / 1.25}px`;
  let translateX;
  const offsetX = w / 1.25 + 20;
  const offsetXActive = w + 20;
  if (rowNumber === 0) {
    if (isActive) {
      translateX = offsetX;
    } else {
      translateX = 0;
    }
  }
  if (rowNumber === 1) {
    if (isActive) {
        translateX = 0;
    } else {
        translateX = activeIndex === 0 ? -offsetXActive : offsetXActive;
    }
  }
  if (rowNumber === 2) {
    if (isActive) {
      translateX = -offsetX;
    } else {
      translateX = 0;
    }
  }
  return css`
    width: ${width};
    height: ${height};
    transform: translateX(${translateX}px);
  `;
}

export const SliderItem = styled.div<{activeIndex?: number, rowNumber?: number}>`
  border-radius: 40px;
  border: 1px;
  background: #FFFFFF;
  transition: all 0.3s linear;
  ${({activeIndex = 0, rowNumber = 0}) => positioning(activeIndex, rowNumber, 450, 630)};

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    ${({activeIndex = 0, rowNumber = 0}) => positioning(activeIndex, rowNumber, 550, 750)};
  }
`

export const CardTitle = styled.div<CardItemProps>`
  font-size: ${({isActive}) => isActive ? 26 : 20}px;
  line-height: 40px;
  font-weight: 600;
  text-align: center;
  color: rgba(224, 224, 224, 1);
  height: 80px;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: ${({isActive}) => isActive ? 32 : 26}px;
    line-height: 60px;
  }
`

export const CardContent = styled.div<CardItemProps>`
  display: flex;
  flex-direction: column;
  ${({isActive}) =>
    isActive
      ? css`
          gap: 10px;
          margin-top: 30px;
          margin-bottom: 30px;
        `
      : css`
          gap: 5px;
          margin-top: 10px;
          margin-bottom: 10px;
        `
  };

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    ${({isActive}) =>
      isActive
        ? css`
            gap: 30px;
            margin-top: 30px;
            margin-bottom: 30px;
          `
        : css`
            gap: 10px;
            margin-top: 10px;
            margin-bottom: 10px;
          `
    };
  }
`

export const CardDesc = styled.div<CardItemProps>`
  padding: 0 20px;
  font-size: ${({isActive}) => isActive ? 16 : 14}px;
  line-height: 25px;
  font-weight: 400;
  text-align: center;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 0 50px;
    font-size: ${({isActive}) => isActive ? 20 : 16}px;
    line-height: 30px;
  }
`

export const CardItem = styled.div`
  
`

export const CardValue = styled.div<CardItemProps>`
  font-size: ${({isActive}) => isActive ? 22 : 18}px;
  line-height: ${({isActive}) => isActive ? 36 : 30}px;
  font-weight: 600;

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: ${({isActive}) => isActive ? 32 : 24}px;
    line-height: ${({isActive}) => isActive ? 40 : 38}px;
  }
`

export const CardText = styled.div<CardItemProps>`
  font-size: ${({isActive}) => isActive ? 16 : 14}px;
  line-height: 30px;
  font-weight: 400;
  color: rgba(21, 21, 21, 1);

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: ${({isActive}) => isActive ? 22 : 16}px;
    line-height: 40px;
  }
`

export const CardFooter = styled.div<CardItemProps>`
  padding: 0 50px;
`

export const CardButton = styled.button<CardItemProps>`
  width: 100%;
  border-radius: 40px;
  border: none;
  cursor: pointer;
  line-height: 33px;
  color: rgba(255, 255, 255, 1);
  ${({isActive}) =>
      isActive
          ? css`
            padding: 15px 0;
            font-size: 20px;
          `
          : css`
            padding: 10px 0;
            font-size: 16px;
          `
  };

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    padding: 20px 0;
    ${({isActive}) =>
      isActive
          ? css`
            padding: 20px 0;
            font-size: 24px;
          `
          : css`
            padding: 15px 0;
            font-size: 18px;
          `
    };
  }
`

export const Card = styled.div<CardProps>`
  border-radius: 40px;
  width: 100%;
  height: 100%;
  text-align: center;

  ${({variant, theme}) => {
    const url = ({
      [CardVariant.BASE]: Basic,
      [CardVariant.PRO]: Pro,
      [CardVariant.ENTERPRISE]: Enterprise,
    })[variant];
    const color = ({
      [CardVariant.BASE]: theme.business.colors.tariffBase,
      [CardVariant.PRO]: theme.business.colors.tariffPro,
      [CardVariant.ENTERPRISE]: theme.business.colors.tariffEnterprise,
    })[variant];
    return css`
      background: url(${url}) no-repeat top;
      color: ${color};

      & button {
        background: ${color};
      }
    `
  }
};
`

export const CrossedText = styled.span`
  text-decoration: line-through;
  color: rgba(255, 255, 255, 0.5);
`
